import { type ComponentProps, type ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import { CellChevron } from './chevron'

interface CellHeaderProps extends ComponentProps<'div'> {
  indicator?: ReactNode
  showChevron?: boolean
}

function CellHeader({ className, children, indicator, showChevron = true, ...props }: CellHeaderProps) {
  return (
    <div data-slot="cell-header" className={twMerge('flex flex-1 items-center gap-2', className)} {...props}>
      <div data-slot="cell-header-content" className={twMerge('flex min-w-0 flex-1 items-center gap-2')}>
        {children}
      </div>
      {indicator}
      {showChevron && <CellChevron className="shrink-0" />}
    </div>
  )
}

export { CellHeader }
